import { IFilterCategory, IFilterElement } from "components/Filter";
import { NUMBER_0 } from "constants/numbers";
import { FALSE, TRUE } from "constants/primitives";
import { VENDORS_FILTER_CATEGORIES } from "constants/vendors";
import { TCF_AVAILABLE_FILTERS } from "helpers/tcf/constantsTCF";
import { VendorTypes } from "helpers/tcf/TCFConsentProvider/types";

/**
 *
 * @param id - id of the element/category that should be updated
 * @param category - category of the given element, if that element is entire category, or is part of specific category
 * @param shouldBeVisible - if the element should be enabled or not
 * @param currentCategories - current state of categories
 * @returns
 */
const filterVendors = ({
  id,
  category,
  shouldBeVisible,
  currentCategories,
  isTcfEnabled,
}: {
  id: IFilterElement["id"];
  category: IFilterElement["category"];
  shouldBeVisible: IFilterElement["isVisible"];
  currentCategories: IFilterCategory[] | [];
  isTcfEnabled: boolean;
}): IFilterCategory[] | [] => {
  const tempFilterCategories = [...currentCategories];

  // Search for category that should be updated
  const catToUpdate = tempFilterCategories.findIndex(
    (cat) => cat.id === category
  );
  if (catToUpdate >= NUMBER_0) {
    // Search for value that should be updated
    const valueToUpdate = tempFilterCategories[catToUpdate].values.findIndex(
      (item) => item.id === id
    );
    if (valueToUpdate >= NUMBER_0) {
      tempFilterCategories[catToUpdate].values[valueToUpdate].isVisible =
        shouldBeVisible;
    }
  }

  // Part about tcf filters
  if (isTcfEnabled) {
    // Check if category is one of the "big categories" and 'tcf because if so, we need to disable/enable all subcategories that are part of tcf
    if (category === VENDORS_FILTER_CATEGORIES && id === VendorTypes.IAB) {
      TCF_AVAILABLE_FILTERS.forEach((tcfCatName) => {
        const catIndex = tempFilterCategories.findIndex(
          (cat) => cat.id === tcfCatName
        );
        tempFilterCategories[catIndex].values.forEach((value, index) => {
          tempFilterCategories[catIndex].values[index].isVisible =
            shouldBeVisible;
        });
      });
    }

    // If the category that has been updated is part of TCF categories
    // This check is useless at this point, as this function is being used only when TCF is enabled. TODO: refactor in future
    if (
      isTcfEnabled &&
      // @ts-expect-error: Typescript screams that category might be string and not same type as TCF_AVAILABLE_FILTERS. But that's exactly what we want to check here. To check if category (string) is part of TCF_AVAILABLE_FILTERS
      TCF_AVAILABLE_FILTERS.includes(category)
    ) {
      // Check if entire tcf filter should or shouldn't be enabled
      let shouldTCFFilterBeEnabled = FALSE;

      TCF_AVAILABLE_FILTERS.forEach((tcfCategory) => {
        tempFilterCategories[
          tempFilterCategories.findIndex((item) => item.id === tcfCategory)
        ].values.forEach((item) => {
          if (item.isVisible) {
            shouldTCFFilterBeEnabled = TRUE;
          }
        });
      });

      // If at least one is enabled, make toggle enabled,
      const catIndex = tempFilterCategories.findIndex(
        (cat) => cat.id === VENDORS_FILTER_CATEGORIES
      );
      if (shouldTCFFilterBeEnabled) {
        tempFilterCategories[catIndex].values[
          tempFilterCategories[catIndex].values.findIndex(
            (value) => value.id === VendorTypes.IAB
          )
        ].isVisible = shouldTCFFilterBeEnabled;
      }
    }
  }

  return tempFilterCategories;
};

export default filterVendors;
